// src/views/letters/components/LetterButton.tsx
// Kopia src/views/kiddo-games/letters/components/LetterButton.tsx — tylko dla Literuj Regular
import React from 'react';
import classes from '../LettersView.module.less';

interface LetterButtonProps {
  letter: string;
  isPlaced: boolean;
  isWrong: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const LetterButton: React.FC<LetterButtonProps> = ({
  letter,
  isPlaced,
  isWrong,
  onClick,
}) => {
  const className = `${classes.letterButton}${isPlaced ? ` ${classes.letterButtonPlaced}` : ''}${
    isWrong ? ` ${classes.letterButtonWrong}` : ''
  }`;

  return (
    <button
      className={className}
      onClick={onClick}
      disabled={isPlaced}
      type="button"
    >
      {letter}
    </button>
  );
};
